var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"p-3 pt-0",attrs:{"loading":_vm.loading,"flat":""}},[_c('mixed-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"fetch-data":_vm.getDataForTable,"reload-table":_vm.reloadTable,"tbProps":_vm.tableProps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }